module.exports = __webpack_public_path__ + "img/inprecord.d1de0997.png";